import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import './store.css';
import StoreCard from './store_card';
import CheckoutDialog from './checkout_dialog';
import { LoadingImage } from './styles';
import logo from '../../assets/logos/bolt.png';
import { shopErrorMessage, useShopCatalog } from '../../features/marketplace';
import { LegalLinks, StoreHead } from '../../features/marketplace/storefront/StorefrontPage';
import '../../features/marketplace/storefront/storefront.css';

// One product: the store's big card (title, rotated creator line, photos, big
// price, stretched BUY, "(n) in cart") under the store header.

const ProductPage: React.FC = () => {
  const { productId } = useParams();
  const { config, products, loading, error, reload } = useShopCatalog();
  const index = products.findIndex((p) => p.id === productId);
  const product = index >= 0 ? products[index] : null;

  useEffect(() => {
    document.title = product ? `${product.name} · NΛSOS Store` : 'NΛSOS Store';
  }, [product]);

  return (
    <div className="sf-page">
      <StoreHead config={config} />
      <nav className="sf-crumbs" aria-label="Breadcrumb">
        <Link to="/marketplace">store</Link>
        <span aria-hidden="true"> / </span>
        <span aria-current="page">{product?.name ?? 'item'}</span>
      </nav>

      {loading ? (
        <div className="store store-message">
          <LoadingImage src={logo} alt="Loading..." />
        </div>
      ) : error ? (
        <div className="sf-state">
          <p className="sf-state-title">Can't reach the store</p>
          <p>{shopErrorMessage(error)}</p>
          <button type="button" className="sf-link-btn" onClick={reload}>
            try again
          </button>
        </div>
      ) : product ? (
        <div className="sf-product-card">
          <StoreCard product={product} index={0} />
        </div>
      ) : (
        <div className="sf-state">
          <p className="sf-state-title">Not in the store</p>
          <p>This item isn't in the store any more.</p>
          <Link to="/marketplace" className="sf-link-btn">
            back to the store
          </Link>
        </div>
      )}

      <LegalLinks config={config} />
      <CheckoutDialog />
    </div>
  );
};

export default ProductPage;
